import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class VisibilityBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.visibility = {
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let value = ko.utils.unwrapObservable(valueAccessor());
                let isCurrentlyVisible = !(element.style.visibility == 'hidden');

                if (value && !isCurrentlyVisible) {
                    element.style.visibility = 'visible';
                    element.style.opacity = '1';
                } else if ((!value) && isCurrentlyVisible) {
                    element.style.visibility = 'hidden';
                    element.style.opacity = '0';
                }
            }
        };
    }
}